import type { FunctionComponent } from "react";

import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";
import { useStyleLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledStyleLogoText } from "./styles";

export type HeaderFeaturesStyleTextLinkProps = {
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  showOnSwap?: SwapCondition;
};

export const HeaderFeaturesStyleTextLink: FunctionComponent<HeaderFeaturesStyleTextLinkProps> = ({
  shouldSwap,
  showIn,
  showOnSwap,
}) => {
  const styleLogoLinkProps = useStyleLogoLinkProps();

  return (
    <Container $shouldSwap={shouldSwap} $showIn={showIn} $showOnSwap={showOnSwap}>
      <StyledLogoLink {...styleLogoLinkProps}>
        <StyledStyleLogoText />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesStyleTextLink.displayName = "HeaderFeaturesStyleTextLink";
